import React from 'react'
import {Navbar} from 'react-bootstrap'

import {Offcanvas} from 'react-bootstrap'
import { Nav }  from 'react-bootstrap'
import { Container }  from 'react-bootstrap'
import { Form }  from 'react-bootstrap'
import { Button }  from 'react-bootstrap'

import './index.css'
import { FormControl }  from 'react-bootstrap'
export default function Header(props) {
  return(
    <>
    <>
  {[false].map((expand) => (
    <Navbar key={expand}  bg="dark" expand={expand} className="mb-3" >
      <h1 id='heading'>miheer recipie finder </h1>
      <Container fluid>
        <h5 id="heading2">**click button at right**</h5>
        
        <Navbar.Toggle className='toggle' aria-controls={`offcanvasNavbar-expand-${expand}`} />
        <Navbar.Offcanvas
          
          id={`offcanvasNavbar-expand-${expand}`}
          aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
              Miheer recipie finder
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 pe-3">
              <h4>step 1:-type the recipie</h4>
              <h4>step 2:-search</h4>
              <h4>step 3:-click on close button</h4>
              
              
            </Nav>
            <Form className="d-flex">
      <FormControl id="search"
      className="me-2"
        placeholder="search your recipie"
        value={props.firstsearch}
        onChange={props.lastsearch}/>
      <Button  id="btn" onClick={props.buttonClick} >
        Button
      </Button>
      </Form>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  ))}
</>
   
    {/* <Form className="d-flex">
      <FormControl id="search"
      className="me-2"
        placeholder="search your recipie"
        value={props.firstsearch}
        onChange={props.lastsearch}/>
      <Button  id="btn" onClick={props.buttonClick} >
        Button
      </Button>
      </Form> */}
 </>
  )}

  
